import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "./LegalLayout";

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const isTh = i18n.language?.startsWith("th") ?? true;

  const sections = isTh
    ? [
        {
          h: "1. ข้อมูลที่เราเก็บรวบรวม",
          p: "เว็บไซต์ Thai Tax & Law อาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน เช่น ชื่อ-นามสกุล อีเมล เบอร์โทรศัพท์ ที่อยู่ ข้อมูลคดี หรือเอกสารทางภาษีและบัญชีที่ท่านส่งให้เรา ผ่านแบบฟอร์มติดต่อ การโทรศัพท์ อีเมล Line หรือช่องทางอื่น ๆ เพื่อให้บริการที่ปรึกษากฎหมายและบัญชีตามที่ท่านร้องขอ",
        },
        {
          h: "2. วัตถุประสงค์ในการใช้ข้อมูล",
          p: "เราจะใช้ข้อมูลของท่านเฉพาะวัตถุประสงค์ดังต่อไปนี้: (1) ให้คำปรึกษาและดำเนินงานตามคำขอของท่าน (2) ติดต่อกลับเพื่อยืนยันนัดหมาย ส่งใบเสนอราคา หรือแจ้งความคืบหน้าของคดี (3) ปฏิบัติตามหน้าที่ตามกฎหมาย ระเบียบของสภาวิชาชีพ และมรรยาททนายความ (4) พัฒนาและปรับปรุงคุณภาพการให้บริการของเรา",
        },
        {
          h: "3. การเปิดเผยข้อมูล",
          p: "เราจะไม่เปิดเผยข้อมูลของท่านให้แก่บุคคลภายนอก เว้นแต่: (1) ได้รับความยินยอมจากท่าน (2) เป็นการดำเนินคดีตามที่ท่านร้องขอ (3) เป็นหน้าที่ตามกฎหมายหรือคำสั่งศาล (4) การจัดทำบัญชีและการสอบบัญชีของสำนักงาน",
        },
        {
          h: "4. การเก็บรักษาข้อมูล",
          p: "เราจะเก็บรักษาข้อมูลของท่านไว้ตลอดระยะเวลาที่จำเป็นสำหรับวัตถุประสงค์ที่ระบุไว้ และตามที่กฎหมายกำหนด (เช่น กฎหมายภาษีอากร กฎหมายบัญชี และมาตรฐานวิชาชีพ) จากนั้นจะดำเนินการทำลายอย่างปลอดภัย",
        },
        {
          h: "5. สิทธิของเจ้าของข้อมูล",
          p: "ท่านมีสิทธิตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ได้แก่ สิทธิในการเข้าถึง ขอสำเนา แก้ไข ลบ ระงับการใช้ คัดค้าน และเพิกถอนความยินยอม รวมถึงสิทธิในการยื่นเรื่องร้องเรียนต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล",
        },
        {
          h: "6. มาตรการรักษาความปลอดภัย",
          p: "เราใช้มาตรการทางเทคนิคและการจัดการที่เหมาะสมเพื่อป้องกันการเข้าถึง ใช้ เปลี่ยนแปลง หรือเปิดเผยข้อมูลโดยมิชอบ รวมถึงการเข้ารหัสข้อมูลที่ละเอียดอ่อนและจำกัดสิทธิการเข้าถึงข้อมูล",
        },
        {
          h: "7. การติดต่อ",
          p: "หากท่านมีคำถามหรือต้องการใช้สิทธิเกี่ยวกับข้อมูลส่วนบุคคล โปรดติดต่อสำนักงาน โทร. 02-276-9968 หรืออีเมล oaoffice@ornthai.com",
        },
      ]
    : [
        {
          h: "1. Information We Collect",
          p: "Thai Tax & Law may collect your personal information — name, email, phone, address, case details, or tax and accounting documents you provide — through our contact form, phone, email, Line, or other channels, to deliver the legal and accounting consulting services you request.",
        },
        {
          h: "2. Purpose of Use",
          p: "We use your information only for: (1) providing advice and acting on your requests; (2) contacting you to confirm appointments, send quotes, or update you on case progress; (3) complying with statutory duties, professional council regulations, and the lawyer's code of conduct; (4) improving the quality of our services.",
        },
        {
          h: "3. Disclosure",
          p: "We do not disclose your information to third parties except: (1) with your consent; (2) when acting on a case at your request; (3) when required by law or court order; (4) for our internal accounting and audit.",
        },
        {
          h: "4. Data Retention",
          p: "We retain your data only as long as necessary for the stated purposes and as required by law (tax law, accounting law, and professional standards). After that, data is securely destroyed.",
        },
        {
          h: "5. Your Rights",
          p: "Under the Personal Data Protection Act B.E. 2562, you have the rights of access, copy, rectification, deletion, restriction, objection, withdrawal of consent, and the right to file a complaint with the Personal Data Protection Committee.",
        },
        {
          h: "6. Security Measures",
          p: "We apply appropriate technical and organizational measures to prevent unauthorized access, use, alteration, or disclosure — including encryption of sensitive data and strict access controls.",
        },
        {
          h: "7. Contact",
          p: "For questions or to exercise your rights regarding personal data, please contact the office at +66 2-276-9968 or oaoffice@ornthai.com.",
        },
      ];

  return (
    <LegalLayout
      title={isTh ? "นโยบายความเป็นส่วนตัว" : "Privacy Policy"}
      subtitle={isTh ? "Privacy Notice ตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล" : "Privacy Notice under the PDPA"}
      lastUpdated={isTh ? "ปรับปรุงล่าสุด: 11 พฤษภาคม 2569" : "Last Updated: May 11, 2026"}
      sections={sections}
    />
  );
}
